var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7002 4.5001C2.7002 4.00304 3.10314 3.6001 3.6002 3.6001H14.4002C14.8973 3.6001 15.3002 4.00304 15.3002 4.5001C15.3002 4.99715 14.8973 5.4001 14.4002 5.4001H3.6002C3.10314 5.4001 2.7002 4.99715 2.7002 4.5001Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7002 9.0001C2.7002 8.50304 3.10314 8.1001 3.6002 8.1001H14.4002C14.8973 8.1001 15.3002 8.50304 15.3002 9.0001C15.3002 9.49715 14.8973 9.9001 14.4002 9.9001H3.6002C3.10314 9.9001 2.7002 9.49715 2.7002 9.0001Z",
    fill: "#4318FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7002 13.5001C2.7002 13.003 3.10314 12.6001 3.6002 12.6001H9.0002C9.49725 12.6001 9.9002 13.003 9.9002 13.5001C9.9002 13.9972 9.49725 14.4001 9.0002 14.4001H3.6002C3.10314 14.4001 2.7002 13.9972 2.7002 13.5001Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.225913bd4442e4cf22e198e630a863f4.svg";
export { ForwardRef as ReactComponent };